import { Section } from "../models/sections.interface";
import { Sections } from "../models/sections.enum";

const mainSection: Array<Section> = [
  // { title: Sections.dashboardTitle, icon: Sections.dashboardIcon, routerLink: Sections.dashboardLink },
]

const settingsSection: Array<Section> = [
  { title: Sections.accountSettingsTitle, icon: Sections.accountSettingsIcon, routerLink: Sections.accountSettingsLink },
  { title: Sections.profileInfoTitle, icon: Sections.profileInfoIcon, routerLink: Sections.profileInfoLink },
];

export { mainSection, settingsSection };
